import React from "react";
import { NavLink } from "react-router-dom";
import "./Preview.css";

interface Props {
  image: string;
  text: string;
  navlink: string;
}

function Preview({ image, text, navlink }: Props) {
  return (
    <div className="feature-preview">
      <NavLink className="nav-button clickable" to={navlink}>
        <img className="feature-preview-image" src={image} alt={text} />
        <div className="feature-preview-image-text">{text}</div>
      </NavLink>
    </div>
  );
}

export default Preview;
